module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="search-result-item">\n  <h3><a href="'+
((__t=( canonical_url ))==null?'':__t)+
'" target="_blank">'+
((__t=( title ))==null?'':__t)+
' version '+
((__t=( description ))==null?'':__t)+
'</a></h3>\n  <ul id="excerpts"></ul>\n</div>';
}
return __p;
};
